module.exports = __webpack_public_path__ + "img/icon-figma.1275ebb0.svg";